module.exports = __webpack_public_path__ + "img/icon_Medical_treatment@2x.394b3429.png";